import React, { useMemo } from "react";
import { Button, Tag } from "@blueprintjs/core";
import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu } from "@mantine/core";

import { usePolicies } from "@hooks";

import { PolicyWithRules } from "@pages/policy/types";

type Props = {
  selectedPolicies: PolicyWithRules[];
  setSelectedPolicies: (p: PolicyWithRules[]) => void;
};

export const PolicySelector: React.FC<Props> = ({
  selectedPolicies,
  setSelectedPolicies,
}) => {
  const policiesQuery = usePolicies();
  const policies = useMemo(
    () => policiesQuery.data?.policies ?? [],
    [policiesQuery.data]
  );
  const unselectedPolicies = useMemo<PolicyWithRules[]>(
    () =>
      policies.filter(
        (p) => selectedPolicies.findIndex((p2) => p2.name === p.name) < 0
      ),
    [selectedPolicies, policies]
  );
  return (
    <>
      {selectedPolicies.map((policy) => (
        <Tag
          intent="primary"
          large
          style={{ marginRight: "8px" }}
          onRemove={() =>
            setSelectedPolicies(selectedPolicies.filter((p) => p !== policy))
          }
        >
          {policy.name}
        </Tag>
      ))}
      <Menu withinPortal>
        <Menu.Target>
          <div>
            <Button minimal style={{ fontSize: "var(--global-font-size-l" }}>
              <FontAwesomeIcon
                color={"var(--global-purple)"}
                icon={faPlusCircle}
              />
            </Button>
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          {unselectedPolicies.length === 0 ? (
            <Menu.Item disabled>All policies applied</Menu.Item>
          ) : (
            unselectedPolicies.map((policy) => (
              <Menu.Item
                onClick={() =>
                  setSelectedPolicies(selectedPolicies.concat(policy))
                }
              >
                {policy.name}
              </Menu.Item>
            ))
          )}
        </Menu.Dropdown>
      </Menu>
    </>
  );
};
